// Selection can be located after a reload only with a real id (synthetic _id
// can't be probed on the server) and a plain selection (select-all/virtual
// works without loaded rows).
export const canLocateSelection = (
  selectedRows: any[],
  selectAllChecked: boolean,
  selectedVirtualRows: number,
  idItem: string | undefined
): boolean =>
  selectedRows.length > 0 &&
  !selectAllChecked &&
  selectedVirtualRows === 0 &&
  Boolean(idItem);
